import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import '../Pagination.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { runMdMutation, isMdMutationLocked } from '../../services/mdMutationGuard';
import { MD_PAGE_SIZE, fetchAndApplyIndexPage } from '../../services/mdServerIndex';
import { ConfirmDialog } from '../common/ConfirmDialog';
import {
  MdRowActions,
  MdTableActionsCell,
  MdTableCell,
  MdTableHeaderCell,
} from '../common/MdRowActions';
import { PlusIcon, SearchIcon } from '../common/mdPageIcons';
import { InscripcionExamenErrorMessage } from './InscripcionExamenErrorMessage';

function getEstadoInscripcion(estado) {
  if (estado === 'A') return 'Activa';
  if (estado === 'P') return 'Pendiente';
  if (estado === 'G') return 'Acta Generada';
  return 'Lista';
}

function getEstadoBadgeClass(estado) {
  if (estado === 'P') return 'md-page__badge md-page__badge--warning';
  if (estado === 'A') return 'md-page__badge md-page__badge--success';
  if (estado === 'G') return 'md-page__badge md-page__badge--info';
  return 'md-page__badge';
}

function getCondicionLabel(rawCondicion) {
  const value = (rawCondicion || '').trim();
  if (value === 'R' || value.toLowerCase() === 'regular') return 'Regular';
  if (value === 'L' || value.toLowerCase() === 'libre') return 'Libre';
  if (value === 'E' || value.toLowerCase() === 'equivalencia') return 'Equivalencia';
  return value || '—';
}

function getCondicionBadgeClass(rawCondicion) {
  const value = (rawCondicion || '').trim();
  if (value === 'R' || value.toLowerCase() === 'regular') {
    return 'md-page__badge md-page__badge--success';
  }
  if (value === 'L' || value.toLowerCase() === 'libre') {
    return 'md-page__badge md-page__badge--warning';
  }
  if (value === 'E' || value.toLowerCase() === 'equivalencia') {
    return 'md-page__badge md-page__badge--info';
  }
  return 'md-page__badge md-page__badge--neutral';
}

function formatPeriodoExamenResumen(periodo) {
  const periodoText = (periodo.periodoExamen || '').trim();
  const llamado = (periodo.llamado || '').trim();
  return [periodoText, llamado].filter(Boolean).join(' - ');
}

export class MDInscripcionExamen extends Component {
  static displayName = MDInscripcionExamen.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      searchInput: '',
      perPage: MD_PAGE_SIZE,
      paginationData: [],
      totalCount: 0,
      pageCount: 0,
      offset: 0,
      currentPage: 0,
      showErrorMessage: false,
      errorMessage: '',
      successMessage: '',
      deletingId: null,
      activatingId: null,
      pendingDelete: null,
      pendingActivate: null,
    };
    this.searchInputRef = React.createRef();
  }

  componentDidMount() {
    if (constantClass.canAccess('WWInscripcionExamen')) {
      this.populateData();
    }
  }

  handleRemoveItem = (periodo) => {
    if (isMdMutationLocked(this)) return;
    this.setState({
      pendingDelete: {
        id: periodo.inscripcionExamenCod,
        nombre: periodo.alumno + ' — ' + periodo.materia,
      },
    });
  };

  handleActivateRequest = (periodo) => {
    if (isMdMutationLocked(this)) return;
    this.setState({
      pendingActivate: {
        id: periodo.inscripcionExamenCod,
        nombre: periodo.alumno + ' — ' + periodo.materia,
      },
    });
  };

  handleCancelDelete = () => {
    if (this.state.deletingId) return;
    this.setState({ pendingDelete: null });
  };

  handleConfirmDelete = () => {
    const { pendingDelete } = this.state;
    if (!pendingDelete || isMdMutationLocked(this)) return;
    this.deleteItem(pendingDelete.id);
  };

  handleCancelActivate = () => {
    if (this.state.activatingId) return;
    this.setState({ pendingActivate: null });
  };

  handleConfirmActivate = () => {
    const { pendingActivate } = this.state;
    if (!pendingActivate || isMdMutationLocked(this)) return;
    this.changeItem(pendingActivate.id);
  };

  handlePageClick = (e) => {
    this.populateData(e.selected, this.state.searchInput);
  };

  handleSearchInputChange = (e) => {
    const searchInput = e.target.value;
    const cleared = searchInput.trim() === '';
    this.setState({ searchInput, successMessage: '', showErrorMessage: false, errorMessage: '' });
    if (cleared && this.state.searchInput.trim() !== '') {
      this.populateData(0, '', { background: false });
    }
  };

  clearFeedback = () => {
    this.setState({ successMessage: '', showErrorMessage: false, errorMessage: '' });
  };

  handleSearchSubmit = (e) => {
    e.preventDefault();
    const search = (this.searchInputRef.current
      ? this.searchInputRef.current.value
      : this.state.searchInput).trim();
    this.setState({ searchInput: search });
    this.populateData(0, search, { background: false });
  };

  buildRowActions(periodo) {
    const id = periodo.inscripcionExamenCod;
    const estado = periodo.inscripcionExamenEstado;
    const actions = [];

    if (estado === 'P' || estado === 'A') {
      actions.push({
        key: 'edit',
        label: 'Modificar',
        variant: 'primary',
        icon: 'pencil',
        to: '/update-ie/' + id + '/0',
      });
      actions.push({
        key: 'delete',
        label: this.state.deletingId === id ? 'Eliminando...' : 'Borrar',
        variant: 'danger',
        icon: 'trash',
        onClick: () => this.handleRemoveItem(periodo),
        disabled: this.state.loading || this.state.deletingId === id,
      });
    }

    actions.push({
      key: 'detail',
      label: 'Detalles',
      variant: 'outline',
      icon: 'info',
      to: '/update-ie/' + id + '/1',
    });

    if (estado === 'P') {
      actions.push({
        key: 'activate',
        label: this.state.activatingId === id ? 'Activando...' : 'Activar',
        variant: 'primary',
        icon: 'check',
        onClick: () => this.handleActivateRequest(periodo),
        disabled: this.state.loading || this.state.activatingId === id,
      });
    }

    return actions;
  }

  renderTable(periodos) {
    return (
      <div className="md-page__table-card">
        <table className="md-page__table md-page__table--actions-fixed md-inscripcion-examen__table" aria-labelledby="md-inscripcion-examen-title">
          <colgroup>
            <col className="md-inscripcion-examen__col-alumno" />
            <col className="md-inscripcion-examen__col-carrera" />
            <col className="md-inscripcion-examen__col-fecha-inscripcion" />
            <col className="md-inscripcion-examen__col-estado" />
            <col className="md-inscripcion-examen__col-materia" />
            <col className="md-inscripcion-examen__col-condicion" />
            <col className="md-inscripcion-examen__col-fecha-examen" />
            <col className="md-inscripcion-examen__col-periodo" />
            <col className="md-inscripcion-examen__col-actions" />
          </colgroup>
          <thead>
            <tr>
              <MdTableHeaderCell cellType="text" className="md-inscripcion-examen__cell md-inscripcion-examen__cell--alumno">Alumno</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text" className="md-inscripcion-examen__cell md-inscripcion-examen__cell--carrera">Carrera</MdTableHeaderCell>
              <MdTableHeaderCell cellType="date" className="md-inscripcion-examen__cell md-inscripcion-examen__cell--fecha-inscripcion">Inscripción</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text" className="md-inscripcion-examen__cell md-inscripcion-examen__cell--estado md-page__table__badge-cell md-page__table__badge-cell--lg">Estado</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text" className="md-inscripcion-examen__cell md-inscripcion-examen__cell--materia">Materia</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text" className="md-inscripcion-examen__cell md-inscripcion-examen__cell--condicion md-page__table__badge-cell">Condición</MdTableHeaderCell>
              <MdTableHeaderCell cellType="date" className="md-inscripcion-examen__cell md-inscripcion-examen__cell--fecha-examen">Fecha Examen</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text" className="md-inscripcion-examen__cell md-inscripcion-examen__cell--periodo">Período</MdTableHeaderCell>
              <th scope="col" className="md-page__table__actions-header" aria-label="Acción" />
            </tr>
          </thead>
          <tbody>
            {periodos.map((periodo) => (
              <tr key={periodo.inscripcionExamenCod}>
                <MdTableCell cellType="text" className="md-inscripcion-examen__cell md-inscripcion-examen__cell--alumno">{periodo.alumno}</MdTableCell>
                <MdTableCell cellType="text" className="md-inscripcion-examen__cell md-inscripcion-examen__cell--carrera">{periodo.carrera}</MdTableCell>
                <MdTableCell cellType="date" className="md-inscripcion-examen__cell md-inscripcion-examen__cell--fecha-inscripcion">
                  {constantClass.formatDisplayDate(periodo.inscripcionExamenFechaHora)}
                </MdTableCell>
                <MdTableCell cellType="text" className="md-inscripcion-examen__cell md-inscripcion-examen__cell--estado md-page__table__badge-cell md-page__table__badge-cell--lg">
                  <span className={getEstadoBadgeClass(periodo.inscripcionExamenEstado)}>
                    {getEstadoInscripcion(periodo.inscripcionExamenEstado)}
                  </span>
                </MdTableCell>
                <MdTableCell cellType="text" className="md-inscripcion-examen__cell md-inscripcion-examen__cell--materia">{periodo.materia}</MdTableCell>
                <MdTableCell cellType="text" className="md-inscripcion-examen__cell md-inscripcion-examen__cell--condicion md-page__table__badge-cell">
                  <span className={getCondicionBadgeClass(periodo.inscripcionExamenCondicionInsc)}>
                    {getCondicionLabel(periodo.inscripcionExamenCondicionInsc)}
                  </span>
                </MdTableCell>
                <MdTableCell cellType="date" className="md-inscripcion-examen__cell md-inscripcion-examen__cell--fecha-examen">
                  {constantClass.formatDisplayDate(periodo.fechaExamen)}
                </MdTableCell>
                <MdTableCell cellType="text" className="md-inscripcion-examen__cell md-inscripcion-examen__cell--periodo">
                  {formatPeriodoExamenResumen(periodo)}
                </MdTableCell>
                <MdTableActionsCell>
                  <MdRowActions items={this.buildRowActions(periodo)} />
                </MdTableActionsCell>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const isBusy = this.state.loading || this.state.searching;
    const listLoading = this.state.loading && !this.state.deletingId && !this.state.activatingId;
    const { pendingDelete, pendingActivate } = this.state;

    const contents = listLoading
      ? <p className="md-page__loading"><em>Cargando datos...</em></p>
      : this.renderTable(this.state.paginationData);

    return (
      <div className="md-page md-inscripcion-examen">
        <h1 id="md-inscripcion-examen-title" className="md-page__title">Manejar Datos de Inscripciones a Exámenes</h1>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <InscripcionExamenErrorMessage
              message={this.state.errorMessage}
              className="md-page__error"
            />
          ) : null}
          {this.state.successMessage ? (
            <div className="md-page__success">{this.state.successMessage}</div>
          ) : null}
        </div>

        <div className="md-page__toolbar">
          <Link className="md-page__action-link" to="/add-ie">
            <PlusIcon />
            Nueva Inscripción a Examen
          </Link>
        </div>

        <form className="md-page__search-row" onSubmit={this.handleSearchSubmit}>
          <div className="md-page__search-wrap">
            <span className="md-page__search-icon">
              <SearchIcon />
            </span>
            <input
              ref={this.searchInputRef}
              className="md-page__search-input"
              type="text"
              name="search"
              autoComplete="off"
              disabled={isBusy}
              placeholder="Ingrese Alumno o Materia"
              value={this.state.searchInput}
              onChange={this.handleSearchInputChange}
            />
          </div>
          <button type="submit" className="md-page__search-btn" disabled={isBusy}>
            Buscar
          </button>
        </form>

        {contents}

        {!listLoading && this.state.pageCount > 0 ? (
          <div className="md-page__pagination">
            <ReactPaginate
              previousLabel="Anterior"
              nextLabel="Siguiente"
              breakLabel="..."
              breakClassName="break-me"
              pageCount={this.state.pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              forcePage={Math.floor(this.state.offset / this.state.perPage)}
              onPageChange={this.handlePageClick}
              containerClassName="pagination"
              subContainerClassName="pages pagination"
              activeClassName="active"
            />
          </div>
        ) : null}

        <ConfirmDialog
          open={Boolean(pendingDelete)}
          title="Eliminar inscripción"
          message="Esta acción eliminará la inscripción a examen y no se puede deshacer."
          detail={pendingDelete ? pendingDelete.nombre : ''}
          confirmLabel="Eliminar"
          cancelLabel="Cancelar"
          variant="danger"
          loading={Boolean(this.state.deletingId)}
          onConfirm={this.handleConfirmDelete}
          onCancel={this.handleCancelDelete}
        />

        <ConfirmDialog
          open={Boolean(pendingActivate)}
          title="Activar inscripción"
          message="¿Desea activar esta inscripción a examen?"
          detail={pendingActivate ? pendingActivate.nombre : ''}
          confirmLabel="Activar"
          cancelLabel="Cancelar"
          variant="primary"
          loading={Boolean(this.state.activatingId)}
          onConfirm={this.handleConfirmActivate}
          onCancel={this.handleCancelActivate}
        />
      </div>
    );
  }

  async populateData(page = 0, search = '', options = {}) {
    await fetchAndApplyIndexPage(this, {
      indexUrl: 'api/ie/Index',
      page,
      search: typeof search === 'string' ? search.trim() : '',
      perPage: this.state.perPage,
      background: options.background,
    });
  }

  async changeItem(id) {
    this.clearFeedback();
    this.setState({ activatingId: id });
    await runMdMutation(this, async () => {
      const { data } = await constantClass.apiFetch('api/ie/changeStatus/' + id, {
        method: 'POST',
      });
      if (data === 'Timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      if (constantClass.isApiError(data)) {
        this.setState({
          showErrorMessage: true,
          errorMessage: constantClass.getApiErrorMessage(
            data,
            'No se pudo activar la inscripción. Intente nuevamente.'
          ),
          pendingActivate: null,
        });
        return;
      }
      this.setState({ successMessage: 'La inscripción se activó correctamente.', pendingActivate: null });
      await this.populateData(this.state.currentPage, this.state.searchInput);
    });
    this.setState({ activatingId: null });
  }

  async deleteItem(id) {
    this.clearFeedback();
    this.setState({ deletingId: id });
    await runMdMutation(this, async () => {
      const { data } = await constantClass.apiFetch('api/ie/delete/' + id, {
        method: 'POST',
      });
      if (data === 'Timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      if (constantClass.isApiError(data)) {
        this.setState({
          showErrorMessage: true,
          errorMessage: constantClass.getApiErrorMessage(
            data,
            'No se pudo eliminar la inscripción. Intente nuevamente.'
          ),
          pendingDelete: null,
        });
        return;
      }
      this.setState({ successMessage: 'La inscripción se eliminó correctamente.', pendingDelete: null });
      await this.populateData(this.state.currentPage, this.state.searchInput);
    });
    this.setState({ deletingId: null });
  }
}
